<template>
  <div class="goods-box my-form">
    <!-- <img v-if="user && user.avatarUrl" :src="user.avatarUrl"> -->

    <div class="registered">
      <van-form @submit="onSubmit" label-width="1.85rem" class="reg_from" show-error :show-error-message="false">
        <van-field v-model="form.Username" name="Name" label="Name" placeholder="Please enter your name" required :rules="[{ required: true, message: 'Please enter your name' }]" />
        <van-field
          v-model="form.email"
          type="number"
          name="E-mail"
          label="E-mail"
          placeholder="Please enter your e-mail"
          required
          disabled
          :rules="[{ prequired: true, message: 'Please enter your e-mail' }]"
        >
          <template #button>
            <span class="sendcode code" @click="NewPhoneShow = true">reset</span>
          </template>
        </van-field>

        <van-field
          v-model="form.CompName"
          type="text"
          name="Company"
          label="Company"
          placeholder="Please enter your company"
          required
          :rules="[{ required: true, message: 'Please enter your company' }]"
        />
        <van-field
          v-model="form.JobTitle"
          type="text"
          name="Job title"
          label="Job title"
          placeholder="Please enter your job title"
          required
          :rules="[{ required: true, message: 'Please enter your job title' }]"
        />
        <van-field v-model="form.phoneText" name="Mobile" label="Mobile" placeholder="Please enter your mobile " />
        <van-field
          readonly
          clickable
          name="Region"
          :value="form.area"
          label="Region"
          placeholder="Please select region"
          @click="showArea = true"
          required
          :rules="[{ required: true, message: 'Please select region' }]"
        />
        <van-popup v-model="showArea" position="bottom">
          <van-picker title="Cuntry" confirm-button-text="confirm" cancel-button-text="cancel" show-toolbar :columns="countryList" @confirm="onConfirm" @cancel="showArea = false" />
        </van-popup>
        <van-cell title="Interest" class="cate_cell" is-link @click="regCareShow" v-if="categoryNum != ''">
          <p v-if="categoryNum != ''">
            <span style="margin-right:0.2rem">{{ categoryNum }}</span
            >choosed
          </p>
        </van-cell>
        <!-- :value="'已选择'+categoryNum+'个'" -->
        <van-cell title="Interest" is-link value="Please select one" class="cate_cell" @click="regCareShow" v-if="categoryNum == ''" />
        <!-- <div>
              <p class="intro_title">Self-introduction</p>
                <van-field
                    class="intro_cell"
                    v-model="form.introduction"
                    rows="4"
                    type="textarea"
                    maxlength="500"
                    placeholder="Add a brief introduction"
                    :rules="[{ required: true, message: 'Add a brief introduction' }]"
                    />
            </div> -->

        <div class="vant-btn">
          <van-button round block type="info" native-type="submit">
            Save
          </van-button>
        </div>
      </van-form>
    </div>

    <!-- 注册条款 -->
    <!-- <frame :showFrame="showFrame" @agree="showFrame = false ; checkbox = true"></frame> -->

    <categoryPop ref="regCare" :cateList="categoryList" :selectList="categoryList1" @closePop="closePop"></categoryPop>

    <van-overlay :show="NewPhoneShow" class="phone_over" :close-on-click-overlay="false">
      <div class="phone_pop">
        <div class="inquiry_title">Reset e-mail</div>
        <van-cell-group>
          <div class="input_read">
            <p>New e-mail</p>
            <input v-model="newphone" />
          </div>
          <div class="input_read">
            <p>Code</p>
            <input type="number" maxlength="6" v-model="newcode" />
            <span v-if="newTimer">{{ newCount || 0 }}s</span>
            <span @click="getCode" v-else style="color:#1890ff">send</span>
          </div>
        </van-cell-group>
        <div class="submit_btn">
          <span @click="cancelphone">Cancel</span>
          <span @click="editphone">Confirm</span>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import provincial from "@/assets/js/provincial.json"; //省市区json
import frame from "./frame"; // 条款弹框
import categoryPop from "./categoryPop"; // 类别弹框

export default {
  data() {
    return {
      form: {
        Username: "", // 姓名
        email: "", // 邮箱
        phoneText: "", // 手机号
        CompName: "", // 公司名
        JobTitle: "", // 职务
        area: "", // 省份
        category: "",
        introduction: "",
        flagStyle: "", // 国旗
      },
      //验证码
      code: "",
      count: 0,
      newCount: 0,
      timer: null,
      newTimer: null,
      codeKey: "",
      //验证码
      pattern: /^1[3456789]\d{9}$/, // 校验手机号

      areaList: [], // 地区数据
      areavalue: [], // 选中的地区数据
      cityCode: "", //省市区编号，默认
      checkbox: false,
      showArea: false,
      showFrame: false, //  显示条款
      categoryNum: "",
      categoryList1: [], //感兴趣类型的选中数组
      showCategory: false, // 显示类别

      NewPhoneShow: false,
      newphone: "",
      newcode: "",
      countryList: [],
    };
  },
  components: { frame, categoryPop },
  computed: {
    ...mapGetters({
      user: "getUserInfo",
      categoryList: "getCategory",
      userId: "getUserId",
      hostInfo: "getHostInfo",
      exhibitionId: "getExhibitionId",
      country: "getCountry",
    }),
  },
  created() {
    this.areaList = provincial;
    this.country.forEach((c) => {
      this.countryList.push(c.nameEn);
    });
    this.init();
  },
  methods: {
    ...mapActions({
      LinkToRegFinsh: "linkTo/LinkToRegFinsh",
      patchUser: "my/patchUser",
      patchUserCategory: "my/patchUserCategory",
      sendCode: "my/sendCode",
      sendEamilCode: "my/sendEamilCode",
      validateCode: "my/validateCode",
      putPhone: "my/putPhone",
      putEmail: "my/putEmail",
      regUser: "my/regUser",
    }),
    async init() {
      let exhibitionId = this.$route.params.id;
      console.log(exhibitionId, "exhibitionId");
      this.$store.commit("setExhibitionId", exhibitionId);
      await this.$Myapollo.getExhibitionInfo(this, exhibitionId, this.userId);
      await this.$Myapollo.getCategory(this, this.exhibitionId);
      await this.$Myapollo.getUserInfo(this);
      this.form.Username = this.user.name || this.user.nickName;
      this.form.phoneText = this.user.phoneText;
      this.form.email = this.user.email;
      this.form.CompName = this.user.company;
      this.form.JobTitle = this.user.jobTitle;
      if (this.user.inMember.category) {
        this.categoryList1 = this.user.inMember.category.split(";");
        this.categoryNum = this.categoryList1.length;
        this.form.category = this.user.inMember.category;
      }
      if (this.user.province && this.user.city && this.user.county) {
        this.areavalue = [this.user.province, this.user.city, this.user.county];
        this.form.area = this.user.province + "/" + this.user.city + "/" + this.user.county;

        // console.log(this.areavalue);
      } else if (this.user.province && this.user.city) {
        this.form.area = this.user.province + "/" + this.user.city;
        this.areavalue = [this.user.province, this.user.city];
      } else {
        this.form.area = this.user.province;
        this.areavalue = [this.user.province];
      }
      if (this.user.country) {
        this.form.area = this.user.country;
        this.form.flagStyle = this.user.flagStyle;
      }
      this.form.introduction = this.user.introduction;
    },
    onCity(e) {
      //选择地区
      console.log(e, "选择地区");
      let areaList = [];
      e.forEach((c) => {
        areaList.push(c.name);
      });
      this.areavalue = areaList;
      this.form.area = areaList.join("/");
      this.showArea = false;
    },
    onConfirm(e) {
      // 选择国家
      this.form.area = e;
      console.log(e, "选择国家");
      this.showArea = false;
      this.country.forEach((c) => {
        // 选择国旗
        if (c.nameEn == e) {
          this.form.flagStyle = c.shortNameEn;
        }
      });
      console.log(this.form.flagStyle, "this.form.flagStyle");
    },
    async onSubmit() {
      let body = {};
      body = {
        name: this.form.Username,
        avatarUrl: this.user.avatarUrl,
        jobTitle: this.form.JobTitle,
        company: this.form.CompName,
        email: this.form.email,
        phoneText: this.form.phoneText,
        country: this.form.area,
        flagStyle: this.form.flagStyle,
        introduction: this.form.introduction,
      };
      let opt = {
        id: this.user.id,
        body: body,
      };
      let result = await this.patchUser(opt);
      let opt2 = {
        id: this.user.inMember.id,
        body: {
          category: this.form.category,
        },
      };
      let result2 = await this.patchUserCategory(opt2);
      console.log(result);
      console.log(result2, "-----");
      if (result.result && result2.result) {
        // 注册成功
        this.$toast.success("succes");
        this.$router.go(-1);
        // this.LinkToRegFinsh();
      } else {
        // 修改失败
        if (!result.result) {
          this.$toast.fail(result.message);
        }
        if (!result2.result) {
          this.$toast.fail(result2.message);
        }
      }
      // let opt2 = {
      //   id: this.user.inMember.id,
      //   body:{
      //     category: this.form.category
      //   }
      // }
      // let result = await this.patchUserCategory(opt2);
      // console.log(result,'-----')
      // if(result.result){ // 注册成功
      //   this.$toast.success('success');
      //   this.$router.go(-1);
      //   // this.LinkToRegFinsh();
      // } else{  // 修改失败
      //   this.$toast.fail(result.message);
      // }
    },

    regCareShow() {
      // 打开类别弹框
      this.$refs["regCare"].open();
    },

    closePop(checkList, vals) {
      // 选中类别并关闭弹框
      console.log(checkList, "选中的类别", vals);
      this.categoryNum = vals.length;
      this.form.category = checkList;
      this.categoryList1 = checkList.split(";");
      console.log(this.categoryList1, "this.categoryList1");
      console.log(this.form.category, "this.form.category");
    },

    //手机号校验
    validatorPhone(val) {
      return /^1[3456789]\d{9}$/.test(val);
    },
    // 邮箱验证
    validatorEamil(val) {
      return /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(val);
    },
    // 获取手机号验证码
    async getCode() {
      console.log(this.newphone, "123213");
      if (!this.validatorEamil(this.newphone)) {
        this.$toast.fail("error Eamil");
        return;
      } else {
        this.newDownTime();
        let res = await this.sendEamilCode({
          email: this.newphone,
        });
        if (res.result) {
          this.$toast.success("send success");
          this.codeKey = res.data.key;
        } else {
          this.$toast.fail("fail");
        }
      }
    },
    //验证手机号
    async Checkphone() {
      let res = await this.validateCode({
        key: this.codeKey,
        code: this.newcode,
      });
      return new Promise((resolve, reject) => {
        if (res == true) {
          this.resetDown();
          resolve(true);
        } else {
          this.$toast.fail("Validation failed");
          this.resetDown();
          resolve(false);
        }
      });
    },

    resetDown() {
      // 重置验证码
      clearInterval(this.newTimer);
      this.newCount = 0;
      this.newTimer = null;
      this.newcode = "";
    },

    //新手机号倒计时
    newDownTime() {
      const newTIME_COUNT = 60;
      if (!this.newTimer) {
        this.newCount = newTIME_COUNT;
        const newTimer = setInterval(() => {
          let count = this.newCount;
          if (count > 0 && count <= newTIME_COUNT) {
            count--;
            this.newCount = count;
          } else {
            clearInterval(this.newTimer);
            this.newTimer = null;
          }
        }, 1000);
        this.newTimer = newTimer;
      }
    },

    // 取消修改手机号
    cancelphone() {
      this.newphone = "";
      this.newcode = "";
      this.NewPhoneShow = false;
      this.resetDown();
    },
    // 修改手机
    async editphone() {
      if (!this.validatorEamil(this.newphone)) {
        this.$toast.fail("email error");
        return;
      }
      if (!this.newcode) {
        this.$toast.fail("Please enter the verification code");
        return;
      }
      let res1 = await this.Checkphone();
      if (res1) {
        let MobBody = {
          memberId: this.user.id,
          email: this.newphone,
        };
        let data = await this.putEmail(MobBody);
        console.log(data, "data");
        if (data.result) {
          this.$toast.success("Success");
          this.form.email = this.newphone;
          this.cancelphone();
        } else {
          let msg = data.message;
          let msgShow = "Fail";
          if (data.code == 0) {
            if (msg.indexOf("Email不是邮箱") != -1) {
              msgShow = "The Email format is incorrect";
            } else if (msg.indexOf("MemberId无效") != -1) {
              msgShow = "Invalid memberid";
            }
          } else if (data.code == 3) {
            msgShow = "Email already exists";
          }
          this.$toast.fail(msgShow);
          this.resetDown();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.goods-box {
  width: 100%;
  min-height: 100vh;
  background-color: rgb(245, 245, 245);
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    margin: 0.45rem 0;
  }
  .registered {
    width: 100%;
    padding-bottom: 0.9rem;
    .code {
      font-size: 0.3rem;
    }
    .sendcode {
      color: #0190fe;
    }
    .single-checkbox {
      margin: 0.6rem 0 0.8rem 0.3rem;
      display: flex;
      p {
        font-size: 0.3rem;
        margin-left: 5px;
        color: #666;
      }
      span {
        font-size: 0.3rem;
        color: #1890ff;
      }
    }
    .vant-btn {
      position: fixed;
      left: 0;
      bottom: 0;
      z-index: 100;
      width: 100%;
      background: #fff;
      height: 0.94rem;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.2);
      .van-button--block {
        width: 6.5rem;
        height: 0.74rem;
        line-height: 0.74rem;
      }
      span {
        font-size: 0.3rem;
      }
    }
    ::v-deep .reg_from {
      .intro_title {
        height: 0.77rem;
        display: flex;
        align-items: center;
        padding-left: 0.3rem;
        font-size: 0.3rem;
        color: #333;
      }
      .van-cell {
        padding: 0 0.3rem;
        height: 0.98rem;
        display: flex;
        align-items: center;
        // justify-content: center;
        &.intro_cell {
          height: 2.6rem;
        }
        &.cate_cell {
          .van-cell__title {
            flex: 0.4;
          }
          .van-cell__value {
            text-align: left;
            p {
              font-size: 0.3rem;
              span {
                font-size: 0.3rem;
                color: #ff5c00;
              }
            }
          }
        }
        .van-field__label {
          color: #333;
        }
        .van-cell__value {
          .van-field__control {
            color: #666666;
          }
          span {
            font-size: 0.3rem;
          }
        }
      }
    }
  }
}
.phone_over {
  z-index: 101;
}
.phone_pop {
  width: 5.6rem;
  height: 4.36rem;
  padding: 0.35rem 0.35rem 0;
  background: #fff;
  border-radius: 0.15rem;
  //   transform: translate(-50%, -50%);
  overflow: hidden;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  .inquiry_title {
    font-size: 0.3rem;
    text-align: center;
    color: #333;
    line-height: 1.2;
    margin-bottom: 0.23rem;
    letter-spacing: 1px;
    padding-left: 1px;
    font-weight: 600;
  }
  .submit_btn {
    height: 0.9rem;
    width: 100%;
    display: flex;
    position: absolute;
    border-top: 1px solid #d2d3d5;
    left: 0;
    right: 0;
    bottom: 0;
    span {
      line-height: 1rem;
      height: 0.89rem;
      border: none;
      border-radius: 0;
      color: #333;
      font-size: 0.3rem;
      width: 100%;
      text-align: center;
      &:first-child {
        border-right: 1px solid #d2d3d5;
      }
      &:last-child {
        color: #fe5502;
      }
    }
  }
  .van-cell-group {
    .input_read {
      background: #eee;
      color: #666;
      padding: 0 0.2rem;
      width: 100%;
      display: flex;
      justify-content: space-between;
      height: 0.7rem;
      margin-bottom: 0.2rem;
      line-height: 0.7rem;
      p {
        font-size: 0.26rem;
        flex-shrink: 0;
      }
      input {
        outline: none;
        border: none;
        background: #eee;
        text-align: right;
        padding: 0.15rem 0 0.15;
        font-size: 0.26rem;
        width: calc(100% - 1.3rem);
        box-sizing: border-box;
        height: 35px;
      }
    }
    .placeholder {
      color: #bfbfbf;
      font-size: 30rpx;
    }
    .text_area {
      border: 1px solid #eee;
      height: 1.4rem;
      padding: 0.1rem 0.2rem;
      box-sizing: border-box;
      width: 100%;
      font-size: 0.3rem;
      line-height: 0.38rem;
      .van-field__body {
        .van-field__control {
          min-height: 0.95rem;
          font-size: 0.3rem;
          line-height: 0.38rem;
          &::-webkit-input-placeholder {
            /* WebKit browsers */
            color: #bfbfbf;
          }
          &:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 */
            color: #bfbfbf;
          }
          &::-moz-placeholder {
            /* Mozilla Firefox 19+ */
            color: #bfbfbf;
          }
          &:-ms-input-placeholder {
            /* Internet Explorer 10+ */
            color: #bfbfbf;
          }
        }
      }
      .van-field__word-limit {
        line-height: 1;
        font-size: 0.24rem;
        margin-top: 0;
      }
    }
  }
}
</style>
